var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.88379 1.88379H3.13962L3.39079 3.13962M4.39546 8.16296H10.6746L13.1863 3.13962H3.39079M4.39546 8.16296L3.39079 3.13962M4.39546 8.16296L2.95571 9.6027C2.56014 9.99827 2.8403 10.6746 3.39971 10.6746H10.6746M10.6746 10.6746C9.98104 10.6746 9.41879 11.2369 9.41879 11.9305C9.41879 12.624 9.98104 13.1863 10.6746 13.1863C11.3682 13.1863 11.9305 12.624 11.9305 11.9305C11.9305 11.2369 11.3682 10.6746 10.6746 10.6746ZM5.65129 11.9305C5.65129 12.624 5.08903 13.1863 4.39546 13.1863C3.70188 13.1863 3.13962 12.624 3.13962 11.9305C3.13962 11.2369 3.70188 10.6746 4.39546 10.6746C5.08903 10.6746 5.65129 11.2369 5.65129 11.9305Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping-cart.cbdc05f95860601ce536309c525a4db0.svg";
export { ForwardRef as ReactComponent };